import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaCalendarAlt, FaHome, FaUserMd } from "react-icons/fa";
import "../staff/StaffSidebar.css";

const TherapistSidebar = () => {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <h2>Therapist Portal</h2>
      </div>
      <ul className="sidebar-menu">
        <li className="sidebar-item">
          <Link
            to="/therapist"
            className={`sidebar-link ${isActive("/therapist") ? "active" : ""}`}
          >
            <FaHome className="sidebar-icon" />
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="sidebar-item">
          <a href="#therapist-availability" className="sidebar-link">
            <FaCalendarAlt className="sidebar-icon" />
            <span>Availability</span>
          </a>
        </li>
        <li className="sidebar-item">
          <div className="sidebar-link">
            <FaUserMd className="sidebar-icon" />
            <span>My Massage Schedule</span>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default TherapistSidebar;
